import { render, staticRenderFns } from "./SvgSmartphone.vue?vue&type=template&id=27360fe5&"
import script from "./SvgSmartphone.vue?vue&type=script&lang=js&"
export * from "./SvgSmartphone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports